import { Card } from '@indipia/ui-core';
import { formatMonthDayDow } from '@indipia/shared-features';
import { TEXT, formatRequestedDtm, type OrderView } from '../../pages/share/vendorOrderReply.logic';

// C-3-1 발주 내용 카드 — 비어 있는 표시용 값(현장·공종·배송지·남긴 말)은 줄을 숨긴다.
function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex gap-3 py-1 text-sm">
      <dt className="w-20 shrink-0 text-text-muted">{label}</dt>
      <dd className="min-w-0 flex-1 break-words text-text-primary">{children}</dd>
    </div>
  );
}

export function OrderContentCard({ view }: { view: OrderView }) {
  const isChange = view.sendTypeCode === 'ORDER_CHANGE';
  return (
    <Card aria-label={TEXT.cardAriaLabel}>
      <dl>
        {view.companyRepName && <Row label={TEXT.cardRep}>{view.companyRepName}</Row>}
        {view.companyPhone && <Row label={TEXT.cardPhone}>{view.companyPhone}</Row>}
        {formatRequestedDtm(view) && <Row label={TEXT.cardRequestedDtm}>{formatRequestedDtm(view)}</Row>}
        {view.siteLabel && <Row label={TEXT.cardSite}>{view.siteLabel}</Row>}
        {view.workTypeName && <Row label={TEXT.cardWorkType}>{view.workTypeName}</Row>}
        <Row label={TEXT.cardDeliveryDate}>
          <span>{formatMonthDayDow(view.deliveryDate)}</span>
          {isChange && view.oldDeliveryDate && (
            <span className="block text-text-muted">{TEXT.oldDeliveryDate(formatMonthDayDow(view.oldDeliveryDate))}</span>
          )}
        </Row>
        <Row label={TEXT.cardLift}>{view.liftReqYn === 'Y' ? TEXT.liftRequested : TEXT.liftNotRequested}</Row>
        {view.deliveryAddress && <Row label={TEXT.cardAddress}>{view.deliveryAddress}</Row>}
        <Row label={TEXT.cardItems}>
          <ul className="flex flex-col gap-1">
            {view.items.map((it) => (
              <li key={it.itemSeq}>
                <span>{it.itemName}</span>
                {it.itemSpec && <span className="text-text-muted"> {it.itemSpec}</span>}
                <span> · {it.itemQty}{it.itemUnit ? ` ${it.itemUnit}` : ''}</span>
              </li>
            ))}
          </ul>
        </Row>
        {view.orderNote && <Row label={TEXT.cardNote}>{view.orderNote}</Row>}
      </dl>
    </Card>
  );
}
